import React from 'react';
import { Route } from '../Routing/types';
import { NutritionSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/nutrition-settings/*',
    element: <NutritionSettingsPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
